import { Link } from 'react-router';
import { Button } from '../../ui/Button';
import { Mark } from '../../ui/Mark';
import { landing } from '../../copy/landing';
import { nav } from '../../copy/shell';
import s from './MobileTopBar.module.css';

export function MobileTopBar({ onOpenMenu }: { onOpenMenu: () => void }) {
  return (
    <div className={s.bar}>
      <Link to="/overview" className={s.masthead}>
        <Mark size={20} />
        <span className={s.wordmark}>{landing.wordmark}</span>
      </Link>
      <Button variant="secondary" size="md" onClick={onOpenMenu} aria-haspopup="dialog">
        {nav.menu}
      </Button>
    </div>
  );
}

export default MobileTopBar;
